<template>
  <v-container flex grid-list-md>
    <template v-if="!smartLock">
      <smart-lock-message></smart-lock-message>
    </template>
    <template v-else>
    <v-layout row wrap justify-center>
      <v-flex xs12 sm5 md3>
        <v-flex xs12>
          Comprador
        </v-flex>
        <v-flex xs12>
          <v-select
            :items="[
              { text: 'Todos', value: 'todos' },
              { text: 'Empresa', value: 'empresa' },
              { text: 'Cliente', value: 'cliente' },
            ]"
            v-model="filtro_comprador"
            label="Tipo de comprador"
            item-text="text"
            item-value="value"
          ></v-select>
        </v-flex>
        <v-flex xs12>
          <v-select
            :items="items_comprador"
            :disabled="filtro_comprador === 'todos'"
            label="Filtro do comprador"
            item-text="text"
            item-value="value"
            v-model="item_selecionado"
            return-object
          ></v-select>
        </v-flex>
        <v-flex xs12>
          <v-text-field
            v-if="item_selecionado"
            :disabled="filtro_comprador === 'todos'"
            v-model="pesquisa_comprador"
            :label="item_selecionado.text"
          ></v-text-field>
        </v-flex>
      </v-flex>
      <v-divider vertical/>
      <v-flex xs12 sm6 md3>
        <v-flex xs12>
          Vendedor
        </v-flex>
        <v-flex xs12>
          <v-select
            :items="[
              {text: 'Todos', value: 'todos'},
              {text: 'Posto', value: 'posto'},
              {text: 'Empresa', value: 'empresa'},
              {text: 'Rede', value: 'rede'},
            ]"
            label="Tipo de vendedor"
            item-text="text"
            item-value="value"
            v-model="filtro_vendedor"
          ></v-select>
        </v-flex>
        <v-flex xs12>
          <v-select
            :items="dados_vendedor"
            label="Filtro do vendedor"
            item-text="text"
            item-value="value"
            :disabled="filtro_vendedor === 'todos'"
            v-model="dado_selecionado"
            return-object
          ></v-select>
        </v-flex>
        <v-flex xs12>
          <v-text-field
            v-if="dado_selecionado"
            v-model="pesquisa_vendedor"
            :label="dado_selecionado.text"
            :disabled="filtro_vendedor === 'todos'"
          ></v-text-field>
          <!--mask="###.###.###-##"-->
        </v-flex>
      </v-flex>
      <v-divider vertical/>
      <v-flex xs12 sm10 md4>
        <v-flex xs12>Dados da Compra</v-flex>
        <v-layout row wrap justify-center>
          <v-flex xs12>
            <v-text-field
              v-model="numero"
              label="Número"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-flex xs12>
          <v-layout row wrap justify-center>
            <v-flex xs12 sm6 md6 lg4>
              <v-checkbox
                color="primary"
                v-model="abastecida"
                label="Abastecido"
                hide-details
              >
              </v-checkbox>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-layout xs12>
            <v-flex xs6>
              <v-text-field label="Maior que" type="number" v-model="valor"/>
           </v-flex>
           <v-flex xs6>
            <v-text-field
              label="Menor que"
              type="number"
              v-model="menorValor"
            />
           </v-flex>
          </v-layout>
        <v-layout row wrap justify-center>
          <v-flex xs3 sm2 md3>
            <v-select
              :items="itemsData"
              item-text="title"
              item-value="value"
              v-model="filtro_data"
            ></v-select>
          </v-flex>
          <v-flex xs8 sm4 md9>
            <v-menu
                ref="menuData"
                v-model="menuData"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-flex xs12>
                    <v-combobox
                      v-if="filtro_data === 'intervalo'"
                      v-model="intervalo_relatorio"
                      label="Dias"
                      multiple
                      persistent-hint
                      chips
                      small-chips
                      readonly
                      flat
                      prepend-icon="event"
                      required
                      v-on="on"
                    ></v-combobox>
                    <v-combobox
                      v-else-if="filtro_data === 'dia'"
                      v-model="data_relatorio"
                      label="Dia"
                      persistent-hint
                      chips
                      small-chips
                      readonly
                      flat
                      @blur="date = parseDate(data_relatorio)"
                      prepend-icon="event"
                      required
                      v-on="on"
                    ></v-combobox>
                    <v-combobox
                      v-else
                      v-model="mes_relatorio"
                      label="Mes"
                      persistent-hint
                      chips
                      small-chips
                      readonly
                      flat
                      @blur="month = parseDate(mes_relatorio)"
                      prepend-icon="event"
                      required
                      v-on="on"
                    ></v-combobox>
                  </v-flex>
                </template>
                <v-flex xs12>
                  <v-flex xs12>
                    <v-date-picker v-show="filtro_data === 'intervalo'" multiple v-model="dates" type="date" color="primary" no-title @input="dataSelecionada"></v-date-picker>
                  </v-flex>
                  <v-flex xs12>
                    <v-date-picker v-show="filtro_data === 'dia'" v-model="date" type="date" color="primary" no-title @input="dataSelecionada"></v-date-picker>
                  </v-flex>
                  <v-flex xs12>
                    <v-date-picker v-show="filtro_data === 'mes'" v-model="month" type="month" color="primary" no-title @input="dataSelecionada"></v-date-picker>
                  </v-flex>
                </v-flex>
              </v-menu>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs2 md1 align-self-center class="text-xs-right">
        <v-btn icon @click="carregarCompras()">
          <v-icon color="primary">search</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <v-data-table
          :headers="headersCompras"
          :pagination.sync="pagination"
          :total-items="totalItems"
          :items="vouchers"
          :loading="loading"
          hide-actions
        >
          <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
          <template slot="items" slot-scope="props">
            <tr @click="visualizarVoucher(props.item)">
              <td class="text-xs-left">
                {{props.item.numero}}
              </td>
              <td class="text-xs-left">
                <template v-if="props.item.posto">
                  {{ props.item.posto.nome_fantasia }}<br>
                  {{ props.item.posto.cnpj }}
                </template>
                <template v-if="props.item.compra.posto">
                  {{ props.item.compra.posto.nome_fantasia }}<br>
                  {{ props.item.compra.posto.cnpj }}
                </template>
                <template v-else-if="props.item.empresa_vendedora">
                  {{props.item.empresa_vendedora ? props.item.empresa_vendedora.nome_fantasia : ''}}<br>
                  {{props.item.empresa_vendedora ? props.item.empresa_vendedora.cnpj : ''}}
                </template>
                <template v-else-if="props.item.compra.empresa_vendedora">
                  {{props.item.compra.empresa_vendedora ? props.item.compra.empresa_vendedora.nome_fantasia : ''}}<br>
                  {{props.item.compra.empresa_vendedora ? props.item.compra.empresa_vendedora.cnpj : ''}}
                </template>
              </td>
              <td class="text-xs-left">
                {{ props.item.data_inativado ? props.item.data_inativado.split('-').reverse().join('/'): 'Não tem' }}
              </td>
              <td class="text-xs-left">
                <v-tooltip v-if="props.item.compra.confirmado" top>
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on" color="teal">done_all</v-icon>
                    </template>
                    <span>Confirmada</span>
                </v-tooltip>
                <v-tooltip v-else top>
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on" color="red">close</v-icon>
                    </template>
                    <span>Pagamento não efetuado</span>
                </v-tooltip>
              </td>
              <td class="text-xs-left">
                <v-tooltip v-if="props.item.disponivel" top>
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on" color="red">close</v-icon>
                    </template>
                    <span>Voucher não usado</span>
                </v-tooltip>
                <v-tooltip v-else top>
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on" color="teal">done_all</v-icon>
                    </template>
                    <span>Voucher Usado</span>
                </v-tooltip>
              </td>
              <td class="text-xs-left">
                <template v-if="props.item.empresa">
                  {{ props.item.empresa.nome_fantasia }}
                  <b>{{ props.item.empresa.cnpj }}</b>
                </template>
                <template v-if="props.item.usuario_beneficiado">
                  {{ props.item.usuario_beneficiado.pessoa.nome_completo }}
                  {{ props.item.usuario_beneficiado.pessoa.cpf | cpf }}
                </template>
              </td>
              <td class="text-xs-left">
                {{ props.item.valor | currency({ fractionCount: 2 }) }}
              </td>
              <v-tooltip bottom v-if="props.item.usuario_beneficiado && props.item.usuario_beneficiado.pessoa">
                <template v-slot:activator="{ on }">
                  <td class="text-xs-right" v-on="on">
                    <v-avatar>
                        <v-img
                        v-if="props.item.usuario_beneficiado.pessoa.url_imagem_perfil"
                        :src="props.item.usuario_beneficiado.pessoa.url_imagem_perfil"
                        height="30"
                        contain
                        />
                        <v-icon size="30" v-else>perm_identity</v-icon>
                    </v-avatar>
                  </td>
                </template>
                <span>{{`${props.item.usuario_beneficiado.pessoa.nome} ${props.item.usuario_beneficiado.pessoa.sobrenome}`}}</span>
              </v-tooltip>
            </tr>
          </template>
        </v-data-table>
        <div class="text-xs-center pt-2">
          <v-pagination color="info" circle v-model="pagination.page" :length="pages"></v-pagination>
        </div>
      </v-flex>
    </v-layout>
    </template>
    <v-dialog v-if="dialogDetalhes" v-model="dialogDetalhes" width="900">
      <detalhes-voucher :voucher="voucher_selecionado" @carregarVouchers="carregarCompras" @fechar="dialogDetalhes = false"/>
    </v-dialog>
    <v-footer
      absolute
      dense
      style="background: transparent"
    >
      <v-expand-transition>
        <v-toolbar dense v-show="compras.length">
          <v-spacer></v-spacer>
          <v-toolbar-title>
            Total: {{ total_relatorio_compras | currency({ fractionCount: 2 }) }}
          </v-toolbar-title>
        </v-toolbar>
      </v-expand-transition>
    </v-footer>
  </v-container>
</template>

<script>
import SmartLockMessage from '@/components/SmartLockMessage'
import DetalhesVoucher from '@/components/dialogs/DetalhesVoucher'

export default {
  components: { SmartLockMessage, DetalhesVoucher },
  data () {
    return {
      dialogDetalhes: false,
      voucher_selecionado: null,
      filtro_comprador: 'todos',
      filtro_vendedor: 'todos',
      item_selecionado: undefined,
      dados_vendedor: [],
      total_relatorio_compras: 0,
      dado_selecionado: undefined,
      items_comprador: [],
      numero: undefined,
      abastecida: true,
      menuData: false,
      totalItems: null,
      pesquisa_comprador: '',
      pesquisa_vendedor: '',
      menorValor: 0,
      valor: 0,
      vouchers: [],
      pagination: {
        rowsPerPage: 5
      },
      data: {
        cpf: null,
        cnpj: null,
        nsu: null,
        codigo: null,
        dia: null,
        mes: null,
        inicio: null,
        fim: null,
        page: 1
      },
      intervalo_relatorio: [],
      dates: [],
      date: null,
      month: null,
      data_relatorio: null,
      mes_relatorio: null,
      cpf: null,
      cnpj: null,
      nsu: null,
      filtro_data: 'dia',
      items: [
        {
          title: 'Por cliente',
          value: 'cpf'
        },
        {
          title: 'Por posto',
          value: 'cnpj'
        },
        {
          title: 'Por NSU',
          value: 'nsu'
        },
        {
          title: 'Por Código',
          value: 'codigo'
        }
      ],
      itemsData: [
        {
          title: 'Dia',
          value: 'dia'
        },
        {
          title: 'Mês',
          value: 'mes'
        },
        {
          title: 'Intervalo',
          value: 'intervalo'
        }
      ],
      headersCompras: [
        {
          text: 'Código',
          sortable: false,
          align: 'left'
        },
        {
          text: 'Vendedor',
          sortable: false,
          align: 'left'
        },
        {
          text: 'Data do Abastecimento',
          sortable: false,
          align: 'left'
        },
        {
          text: 'Pagamento',
          sortable: false,
          align: 'left'
        },
        {
          text: 'Usada',
          sortable: false,
          align: 'left'
        },
        {
          text: 'Comprador',
          sortable: false,
          align: 'left'
        },
        {
          text: 'Valor',
          sortable: false,
          align: 'left'
        },
        {
          sortable: false,
          align: 'right'
        }
      ]
    }
  },
  computed: {
    pages () {
      if (this.pagination.rowsPerPage == null ||
        this.totalItems == null
      ) return 0

      return Math.ceil(this.totalItems / this.pagination.rowsPerPage)
    },
    smartLock () {
      return this.$store.getters.smartLock
    },
    compras () {
      return this.$store.getters.compras
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  watch: {
    pagination: {
      handler () {
        this.carregarCompras(this.pagination)
      },
      deep: true
    },
    filtro_comprador (val) {
      this.item_selecionado = undefined
      switch (val) {
        case 'empresa':
          this.items_comprador = [
            { text: 'CNPJ', value: 'empresa_beneficiada__cnpj' },
            { text: 'Nome fantasia', value: 'empresa_beneficiada__nome_fantasia__icontains' },
            { text: 'Cidade', value: 'empresa_beneficiada__endereco__cidade__icontains' },
            { text: 'Estado', value: 'empresa_beneficiada__endereco__estado__icontains' },
            { text: 'Veículo', value: 'veiculo__identificacao__icontains' }
          ]
          break
        case 'cliente':
          this.items_comprador = [
              { text: 'CPF', value: 'usuario_beneficiado__pessoa__cpf' },
              { text: 'E-mail', value: 'usuario_beneficiado__pessoa__email' },
              { text: 'Telefone', value: 'usuario_beneficiado__pessoa__telefone' },
              { text: 'Veículo', value: 'veiculo__identificacao__icontains' },
              { text: 'Número de identificação', value: 'usuario_beneficiado__pessoa' }
          ]
          break
        default:
          this.items_comprador = []
      }
    },
    filtro_vendedor (val) {
      this.dado_selecionado = undefined
      switch (val) {
        case 'posto':
          this.dados_vendedor = [
            { text: 'CNPJ', value: 'posto__cnpj' },
            { text: 'Nome fantasia', value: 'posto__nome_fantasia__icontains' },
            { text: 'Cidade', value: 'posto__endereco__cidade__icontains' },
            { text: 'Estado', value: 'posto__endereco__estado__icontains' }
          ]
          break
        case 'rede':
          this.dados_vendedor = [
            { text: 'CNPJ do Matriz', value: 'rede__matriz__cnpj' },
            { text: 'Nome', value: 'rede__nome__icontains' }
          ]
          break
        case 'empresa':
          this.dados_vendedor = [
            { text: 'CNPJ', value: 'empresa_vendedora__cnpj' },
            { text: 'Nome fantasia', value: 'empresa_vendedora__nome_fantasia__icontains' },
            { text: 'Cidade', value: 'empresa_vendedora__endereco__cidade__icontains' },
            { text: 'Estado', value: 'empresa_vendedora__endereco__estado__icontains' }
          ]
          break
        default:
          this.dados_vendedor = []
      }
    },
    date (val) {
      if (val) {
        this.data_relatorio = this.formatDate(this.date)
      }
    },
    month (val) {
      if (val) {
        this.mes_relatorio = this.formatDate(this.month)
      }
    },
    filtro_data (val) {
      if (val) {
        this.data.dia = null
        this.data.mes = null
        this.data.inicio = null
        this.data.fim = null
      }
    }
  },
  filters: {
    cpf: function (value) {
      if (!value) return ''
      value = value.toString()
      value = value.slice(0, 3) + '.' + value.slice(3, 6) + '.' + value.slice(6, 9) + '-' + value.slice(9, 11)
      return value
    }
  },
  methods: {
    formatDate (date) {
      if (!date) return null

      if (this.filtro_data === 'dia' || this.filtro_data === 'intervalo') {
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      } else {
        const [year, month] = date.split('-')
        return `${month}/${year}`
      }
    },
    orderDates () {
      this.dates.sort((a, b) => {
        a = new Date(a.split('-'))
        b = new Date(b.split('-'))
        return a < b ? -1 : a > b ? 1 : 0
      })
    },
    parseDate (date) {
      if (!date) return null

      if (this.filtro_data === 'dia' || this.filtro_data === 'intervalo') {
        const [day, month, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      } else {
        const [month, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}`
      }
    },
    dataSelecionada () {
      if (this.filtro_data === 'intervalo') {
        if (this.dates.length === 3) {
          let day1 = this.dates[0]
          let day2 = this.dates[2]
          this.dates = []
          this.dates = [day1, day2]
        }
        if (this.dates.length) {
          this.orderDates()
        }
        this.intervalo_relatorio = this.dates.map(this.formatDate)
      } else {
        this.menuDataInicial = false
      }
    },
    carregarCompras (pagination) {
      let data = {}
      data.page = pagination ? pagination.page : 1
      if (this.filtro_comprador !== 'todos') {
        data.empresa = this.filtro_comprador === 'empresa'
        if (this.pesquisa_comprador) {
          data[`${this.item_selecionado.value}`] = this.pesquisa_comprador
        }
      }
      if (this.filtro_vendedor !== 'todos') {
        if (this.filtro_vendedor === 'empresa') {
          data.empresa_vendedora__isnull = false
        } else if (this.filtro_vendedor === 'posto') {
          data.posto__isnull = false
        }
        if (this.dado_selecionado) data[`${this.dado_selecionado.value}`] = this.pesquisa_vendedor
      }
      data.disponivel = !this.abastecida
      if (this.valor !== 0 && this.valor !== undefined) {
        data.valor__gte = this.valor
      }
      if (this.menorValor !== 0 && this.menorValor !== undefined) {
        data.valor__lte = this.menorValor
      }
      switch (this.filtro_data) {
        case 'dia':
          if (this.abastecida) {
            data.data_inativado = this.data_relatorio
          } else {
            data.data_gerado = this.data_relatorio
          }
          break
        case 'mes':
          const dataBusca = this.mes_relatorio.split('/')
          if (this.abastecida) {
            data.data_inativado__month = dataBusca[0]
            data.data_inativado__year = dataBusca[1]
          } else {
            data.data_gerado__month = dataBusca[0]
            data.data_gerado__year = dataBusca[1]
          }
          break
        case 'intervalo':
          if (this.abastecida) {
            data.data_inativado__gte = this.intervalo_relatorio[0]
            data.data_inativado__lte = this.intervalo_relatorio[1]
          } else {
            data.data_gerado__gte = this.intervalo_relatorio[0]
            data.data_gerado__lte = this.intervalo_relatorio[1]
          }
          break
      }
      if (this.numero) data.numero__iexact = this.numero
      this.$store.dispatch('pegarVouchers', data).then(json => {
        this.vouchers = json.results.vouchers
        this.totalItems = json.count
        this.total_relatorio_compras = json.results.valor_total
      })
    },
    visualizarVoucher (voucher) {
      this.voucher_selecionado = voucher
      this.dialogDetalhes = true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

</style>
